export var CampaignType;
(function (CampaignType) {
    CampaignType["Individual"] = "Individual";
    CampaignType["Batch"] = "Batch";
    CampaignType["Group"] = "Group";
    CampaignType["AiAgentBatch"] = "Batch:aiAgent";
    CampaignType["AiAgentIndividual"] = "Individual:aiAgent";
})(CampaignType || (CampaignType = {}));
